import { getEndpointV2 } from 'api';
import { fillPath } from 'helpers/api';

export const getPathToFetchAndAdd = (companyId?: string): string =>
  companyId
    ? fillPath({ path: '/auth/company/:companyId/user', urlParams: { companyId } })
    : fillPath({ path: '/auth/company/user' });

export const getUrlToFetchAndAdd = (companyId?: string): string => {
  return getEndpointV2({ path: getPathToFetchAndAdd(companyId) });
};

export const getPathToUpdateAndRemove = (username: string): string =>
  fillPath({
    path: '/auth/user/:username',
    urlParams: { username },
  });

export const getUrlToUpdateAndRemove = (username: string): string => {
  return getEndpointV2({
    path: getPathToUpdateAndRemove(username),
  });
};
